import * as angular from 'angular';
import {IController} from "angular";

export class DeliverySpotsIndication implements IController {
  packageList: any[];
  serviceType: string;

  public spotsSum: number;

  /* @ngInject */
  constructor(private $filter) {
  }

  $onInit() {
    if (this.packageList) {
      this.spotsSum = this.$filter("packageSpots")(this.packageList[0]);
    }
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('deliverySpotsIndication', {
    bindings: {
      packageList: '<?',
      serviceType: '<?',
    },
    template: require('./delivery-spots-indication.html').default,
    controller: DeliverySpotsIndication
  });
